import { makeVar } from '@apollo/client';

export const itemNameVar = makeVar('');

export const editItemPropertyVar = makeVar({ open: false, property: {} });
